import { useEffect, useState } from "react";
import { Phone, FileText } from "lucide-react";
import { scrollToId } from "@/lib/api";

export default function MobileBar({ settings }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const tel = (settings.phone || "").replace(/\s/g, "");

  return (
    <div
      data-testid="mobile-cta-bar"
      className={`mobile-cta-bar fixed bottom-0 inset-x-0 z-50 md:hidden bg-white/95 backdrop-blur-md border-t border-line px-3 py-2.5 flex gap-2.5 pb-[max(0.625rem,env(safe-area-inset-bottom))] transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={`tel:${tel}`}
        data-testid="mobile-call-cta"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border-2 border-forest text-forest font-semibold py-3 text-sm"
      >
        <Phone className="h-4 w-4" />
        Appeler
      </a>
      <button
        onClick={() => scrollToId("#contact")}
        data-testid="mobile-quote-cta"
        className="flex-1 relative cta-playful inline-flex items-center justify-center gap-2 rounded-full bg-terra text-white font-semibold py-3 text-sm"
      >
        <FileText className="h-4 w-4" />
        Devis gratuit
      </button>
    </div>
  );
}
